export var SCOREBOARD_RESET = 'SCOREBOARD_RESET';
export var SCOREBOARD_SET_CATEGORY = 'SCOREBOARD_SET_CATEGORY';
export var SCOREBOARD_SET_ROUND = 'SCOREBOARD_SET_ROUND';
export var SCOREBOARD_SET_TEAM = 'SCOREBOARD_SET_TEAM';
export var SCOREBOARD_SET_ATHLETE = 'SCOREBOARD_SET_ATHLETE';
export var SCOREBOARD_SET_ATHLETE_SCORE = 'SCOREBOARD_SET_ATHLETE_SCORE';
export var SCOREBOARD_SET_ATHLETE_SCORE_ROUTE = 'SCOREBOARD_SET_ATHLETE_SCORE_ROUTE';
export var resetScoreboard = function () {
    return {
        type: SCOREBOARD_RESET,
    };
};
export var setScoreboardCategory = function (categoryId) {
    return {
        type: SCOREBOARD_SET_CATEGORY,
        payload: { categoryId: categoryId },
    };
};
export var setScoreboardRound = function (roundId) {
    return {
        type: SCOREBOARD_SET_ROUND,
        payload: { roundId: roundId },
    };
};
export var setScoreboardTeam = function (teamId) {
    return {
        type: SCOREBOARD_SET_TEAM,
        payload: { teamId: teamId },
    };
};
export var setScoreboardAthlete = function (athleteId) {
    return {
        type: SCOREBOARD_SET_ATHLETE,
        payload: { athleteId: athleteId },
    };
};
export var setScoreboardAthleteScore = function (athleteScoreId) {
    return {
        type: SCOREBOARD_SET_ATHLETE_SCORE,
        payload: { athleteScoreId: athleteScoreId },
    };
};
export var setScoreboardAthleteScoreRoute = function (athleteScoreRouteId) {
    return {
        type: SCOREBOARD_SET_ATHLETE_SCORE_ROUTE,
        payload: { athleteScoreRouteId: athleteScoreRouteId },
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/reducers/actions.ts
// module id = 113
// module chunks = 0